import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'suspicious',
  async getComponent () {
    const {
      default: SuspiciousContainer
    } = await import(/* webpackChunkName: "suspicious-container" */ './containers/SuspiciousContainer')
      .catch(handleChunkLoadError);
    return SuspiciousContainer;
  }
});
